import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system'; 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
export default class  ShippingAddCustomerbox extends Component {
	 constructor(props) {
    super();
	 this.state = {
	search:'',order:'desc' ,orderBy:'cu_id',cu_id:0,billingaddress1:'',billingaddress2:'',billingcity:'',billingstate:'',billingpincode:'',shippingaddress1:'',shippingaddress2:'',shippingcity:'',shippingstate:'',shippingpincode:'',
	cuid:'',open1:false,country:'',countrydata:[],countrylabel:'Select Country',sameaddressdisplay:"1"	,erropen:false,  radiovalue:"1"
      }
	 };
handleErrorclose=(event)=>{
	this.setState({erropen: false});  
  } 
handleClickOpen = (e) => {
  this.setState({ open:!this.state.open,erropen:false,cu_id:0,billingaddress1:'',billingaddress2:'',billingcity:'',billingstate:'',billingpincode:'',shippingaddress1:'',shippingaddress2:'',shippingcity:'',shippingstate:'',shippingpincode:'',coutryarray:[],country:'',countrydata:[],countrylabel:'Select Country',sameaddress:true
		 });
		this.Customergetdata();
this.countrybind();
};
  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 }
 Customergetdata() {
  if(this.props.id!==0)
  {
	   axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=getall&cu_id='+this.props.id)
  .then(resp => {  
    if(resp.data.length>0){
		if(resp.data[0].cu_shippingaddress1==="" ||  resp.data[0].cu_shippingaddress1===resp.data[0].cu_billingaddress1)
		{
		if(this.state.sameaddressdisplay==="1")
		{
		 this.setState({ 	shippingaddress1:resp.data[0].cu_billingaddress1, 
	shippingaddress2:resp.data[0].cu_billingaddress2,
	shippingcity:resp.data[0].cu_billingcity,
	shippingstate:resp.data[0].cu_billingstate,
	shippingpincode:resp.data[0].cu_billingpincode,});
		}
		}
		else{
			this.setState({ 	shippingaddress1:resp.data[0].cu_shippingaddress1, 
	shippingaddress2:resp.data[0].cu_shippingaddress2,
	shippingcity:resp.data[0].cu_shippingcity,
	shippingstate:resp.data[0].cu_shippingstate,
	shippingpincode:resp.data[0].cu_shippingpincode,	
    country:resp.data[0].cu_co_id,sameaddressdisplay:"0",customdisplay:"3",radiovalue:"3"});
		}
    this.setState({ 
      cu_id:resp.data[0].cu_id,	
	billingaddress1:resp.data[0].cu_billingaddress1,
	billingaddress2:resp.data[0].cu_billingaddress2,
	billingcity:resp.data[0].cu_billingcity,
	billingstate:resp.data[0].cu_billingstate,
	billingpincode:resp.data[0].cu_billingpincode,
	shippingaddress1:resp.data[0].cu_shippingaddress1, 
	shippingaddress2:resp.data[0].cu_shippingaddress2,
	shippingcity:resp.data[0].cu_shippingcity,
	shippingstate:resp.data[0].cu_shippingstate,
	shippingpincode:resp.data[0].cu_shippingpincode,	
    country:resp.data[0].cu_co_id,
    });
  }
});
    }
	 }
 countrybind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall')
      .then((resp) => {   
	  let CountryApi = resp.data.map(row => {
          return {value: row.co_id, display:row.co_name}
        });
		 this.setState({
          countrydata: [{value: '', display:'Select Country'}].concat(CountryApi)
        },()=>{console.log(this.state.countrydata)});
      }).then(data => {
		})
}
handleClose = (e) => {
	let shippingaddress1 = this.state.shippingaddress1;
    let shippingaddress2 = this.state.shippingaddress2;
	let shippingcity = this.state.shippingcity;  
	let shippingstate = this.state.shippingstate;
	let shippingpincode = this.state.shippingpincode;
	let country=this.state.country;
	if(country==''){
						this.setState({errormessage:"Please Select Country",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
				}
	if(shippingaddress1==''){
						this.setState({errormessage:"Please Enter Address1",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
				}
	if(shippingaddress2==''){
						this.setState({errormessage:"Please Enter Address2",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
				}
	if(shippingcity==''){
						this.setState({errormessage:"Please Enter City",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
				}
	if(shippingstate==''){
						this.setState({errormessage:"Please Enter State",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
				}
if(shippingpincode==''){
						this.setState({errormessage:"Please Enter Zip Code",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
				}				
 var formData = new FormData();
formData.append('action','addressupdate') 
 formData.append('cu_id',this.state.cu_id) 
  formData.append('cu_country_id',country) 
 formData.append('cu_shippingaddress1',shippingaddress1)
formData.append('cu_shippingaddress2',shippingaddress2)
formData.append('cu_shippingcity',shippingcity)
formData.append('cu_shippingstate',shippingstate)
formData.append('cu_shippingpincode',shippingpincode)		
formData.append('userid',localStorage.getItem("ISIuserid"))
	formData.append('type',2)
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
        }).then(res => {
			this.setState({errormessage:"Record Updated Successfuly",erropen:true	,
		open:false,
		billingaddress1:'',
		billingaddress2:'',
		billingcity:'',		
		billingstate:'',		
		billingpincode:"",
		shippingaddress1:'',
		shippingaddress2:'',
		shippingcity:'',		
		shippingstate:'',		
		shippingpincode:"",			
		cu_id:0
		});
			this.props.shippingupdateDone();
            });
};
 handleRadio = (event) => {
    let setValue= (event.target.value);	
	//alert(setValue);
	this.setState({radiovalue:setValue});		
	if(setValue=="1")
	{
		this.setState({sameaddressdisplay:"1",customdisplay:"0",noaddressdisplay:"0"},()=>{
			this.setState({
			shippingaddress1:this.state.billingaddress1, 
	shippingaddress2:this.state.billingaddress2,
	shippingcity:this.state.billingcity,
	shippingstate:this.state.billingstate,
	shippingpincode:this.state.billingpincode,	
		})	
		})
	}
	else if(setValue=="2")
	{
		this.setState({noaddressdisplay:"2",sameaddressdisplay:"0",customdisplay:"0",shippingaddress1:'', 
	shippingaddress2:'',
	shippingcity:'',
	shippingstate:'',
	shippingpincode:'',},)
	}
	else if(setValue=="3")
	{
		this.setState({customdisplay:"3",noaddressdisplay:"0",sameaddressdisplay:"0",
			shippingaddress1:'', 
	shippingaddress2:'',
	shippingcity:'',
	shippingstate:'',
	shippingpincode:'',	
		})
	}
  };
render (){
const {value, setValue, radiovalue } = this.state;
return(
<React.Fragment>
<Dialog open={this.state.open} onClose={this.onclickbranchclose} maxWidth="lg" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Delivery Address</DialogTitle>
      <DialogContent>	
<div className="formlist">
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	<div className="shippingsellection" >
<RadioGroup aria-label="login"  value={this.state.radiovalue} onChange={this.handleRadio}  inputProps={{ tabIndex: "1" }} defaultValue="1">
<ul>
<li><FormControlLabel value="1" type="1" id="sameaddress" name="sameaddress" control={<Radio />} label="Same as invoice address" />
</li>
<li><FormControlLabel value="2" type="2" control={<Radio />} id="noaddress" name="noaddress" label="No Address" />
</li>
<li><FormControlLabel value="3" type="3" control={<Radio />} id="customaddress" name="customaddress" label="Custom" />
</li>
</ul>    
</RadioGroup>
</div>					  
		<div className="shippingformentry" >	
		{this.state.radiovalue!=="3" && (<div className="formlayer"></div>)}		
	<ul>
 <li> 
		<p className="popformtext"></p>
		<p className="popforminputs"><FormControl  className="txtbox">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.countrylabel, value: this.state.country}}
          onChange={this.myChangeHandler}
          id="country"
		   value={this.state.country} className="txtbox"
		  name="country"
		inputProps={{tabIndex: "1"}}
        >
		{this.state.countrydata.map(country => (
            <option  
              value={country.value}
            >
              {country.display}
            </option  >
          ))}
        </Select></FormControl>
		</p>	<div className="clear"></div>
	</li>
		<li>  
		<p className="popformtext">Address1</p>
		<p className="popforminputs">
		  <TextField 
            variant="outlined"
            margin="normal"
            fullWidth
			value={this.state.shippingaddress1}
            id="shippingaddress1"
          className="txtbox"
            name="shippingaddress1" onChange={this.myChangeHandler}
            autoComplete="shippingaddress1"
          /></p>	<div className="clear"></div></li>
		<li>  
		<p className="popformtext">Address2 </p>
		<p className="popforminputs">
		  <TextField 
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.shippingaddress2}
            id="shippingaddress2"
            name="shippingaddress2" onChange={this.myChangeHandler}
            autoComplete="shippingaddress2"/></p>	<div className="clear"></div></li>
		 <li>  
		 <p className="popformtext">City</p>
		 <p className="popforminputs">
		  <TextField 
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.shippingcity}
            id="shippingcity"
            name="shippingcity" onChange={this.myChangeHandler}
            autoComplete="shippingcity"
          /></p>	<div className="clear"></div></li>
		 <li>  
		 <p className="popformtext">State</p>
		 <p className="popforminputs">
		  <TextField 
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.shippingstate}
            id="shippingstate"
            name="shippingstate" onChange={this.myChangeHandler}
            autoComplete="shippingstate"           
          /></p>	<div className="clear"></div></li>
		 <li> 
<p className="popformtext">Pincode</p>
		 <p className="popforminputs">
		  <TextField 
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.shippingpincode}
            id="shippingpincode"
            name="shippingpincode" onChange={this.myChangeHandler}
            autoComplete="shippingpincode"
          /></p>	<div className="clear"></div></li>
		</ul>
     <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
   Save
</Button>
    </div> 	
<div className="clear"></div>
 </div>  </div> <div className="clear"></div>
	  </div>
	  </DialogContent>
    </Dialog>
</React.Fragment>
) }	 
}